export default __webpack_public_path__ + "static/media/Select_PowerShell_Script2.1584ce34.png";